module.exports = __webpack_public_path__ + "static/img/account.3209814.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account.png
// module id = zX4s
// module chunks = 1